import { useMeuPlayState } from "@src/states/meuplay";
import { useOfflineModeState } from "@src/states/offline_mode";

import { OFFLINE_SPOT_URL } from "@src/services/player/constants";

import { getRandom } from "@src/utils/getRandom";
import { setQueryString } from "@src/utils/setQueryString";

const offlineSpot = 2;

export function getNextOfflineUrl() {
  const { cachedUrls, playedUrls, offlineSongsPlayed, insertingOfflineSpot } =
    useOfflineModeState.getState();

  const _cachedUrls = Array.from(cachedUrls);
  const _playedUrls = Array.from(playedUrls);
  const unplayedUrls = _cachedUrls.filter((url) => !_playedUrls.includes(url));

  // insere vinheta `você está offline` a cada N músicas offline.
  const shouldInsertOfflineSpot =
    offlineSongsPlayed % offlineSpot === 0 || offlineSongsPlayed < 0;
  const { radio } = useMeuPlayState.getState();
  if (shouldInsertOfflineSpot && !insertingOfflineSpot && radio?.offline_spot) {
    useOfflineModeState.setState({ insertingOfflineSpot: true });
    return setQueryString(OFFLINE_SPOT_URL, "preloaded", radio.name);
  }

  useOfflineModeState.setState({
    offlineSongsPlayed: offlineSongsPlayed + 1,
    insertingOfflineSpot: false,
  });
  if (_cachedUrls.length > 0 && unplayedUrls.length === 0) {
    // -2 because the last played URL (-1) is the current track
    const randomPlayed = getRandom(0, _playedUrls.length - 2);
    return _playedUrls[randomPlayed];
  }
  const randomUnplayed = getRandom(0, unplayedUrls.length - 1);
  return unplayedUrls[randomUnplayed];
}
